export enum MessageAdminAlertsFilter {
  ALL = 'ALL',
  ONLY = 'ONLY',
  EXCLUDE = 'EXCLUDE',
}
